"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DrinkGroupName = exports.DrinkGroup = void 0;

var _Base = _interopRequireDefault(require("./Base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const DrinkGroup = {
  AGUA: "AGUA",
  CACHACA: "CACHACA",
  CAFE: "CAFE",
  CERVEJA: "CERVEJA",
  CHA: "CHA",
  CONHAQUE: "CONHAQUE",
  ENERGETICO: "ENERGETICO",
  ESPUMANTE: "ESPUMANTE",
  GIM: "GIM",
  ISOTONICO: "ISOTONICO",
  LACTEA: "LACTEA",
  LICOR: "LICOR",
  MILK_SHAKE: "MILK_SHAKE",
  REFRIGERANTE: "REFRIGERANTE",
  RUM: "RUM",
  SAQUE: "SAQUE",
  SUCO: "SUCO",
  TEQUILA: "TEQUILA",
  VINHO: "VINHO",
  VITAMINA: "VITAMINA",
  VODKA: "VODKA",
  WHISKY: "WHISKY",
  OUTROS: "OUTROS"
};
exports.DrinkGroup = DrinkGroup;
const DrinkGroupName = {
  AGUA: "Água",
  CACHACA: "Cachaça",
  CAFE: "Café",
  CERVEJA: "Cerveja",
  CHA: "Chá",
  CONHAQUE: "Conhaque",
  ENERGETICO: "Energético",
  ESPUMANTE: "Espumante",
  GIM: "Gim",
  ISOTONICO: "Isotônico",
  LACTEA: "Láctea",
  LICOR: "Licor",
  MILK_SHAKE: "Milk-shake",
  REFRIGERANTE: "Refrigerante",
  RUM: "Rum",
  SAQUE: "Saquê",
  SUCO: "Suco",
  TEQUILA: "Tequila",
  VINHO: "Vinho",
  VITAMINA: "Vitamina",
  VODKA: "Vodka",
  WHISKY: "Whisky",
  OUTROS: "Outros"
};
exports.DrinkGroupName = DrinkGroupName;

class Drink extends _Base.default {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "type", 'drink');

    _defineProperty(this, "getPrice", () => {
      var _this$sizes;

      let price = ((_this$sizes = this.sizes) === null || _this$sizes === void 0 ? void 0 : _this$sizes.length) > 0 ? +this.sizes[0].getPrice() : +this.price;
      let extraIngredientsPrice = 0;
      (this.extra_ingredients || []).forEach(extra => {
        extraIngredientsPrice += +extra.getPrice();
      });
      let itemPrice = +this.items.reduce((totalPrice, item) => totalPrice + item.getPrice(), 0);
      return (+this.quantity || 0) * (price + itemPrice + extraIngredientsPrice);
    });

    _defineProperty(this, "toJSON", () => {
      let me = this,
          _this = {};
      ['_id', 'ref_id', 'parent', 'type', 'group', 'position', 'name', 'price', 'originalPrice', 'image', 'description', 'items', 'new', 'delete', 'show', 'selected', 'quantity', 'observation', 'highlight', 'sizes', 'extra_ingredients', 'availability', 'categoryName'].map(prop => {
        _this[prop] = me[prop];
      });
      ['price', 'quantity', 'position', 'originalPrice'].map(prop => {
        if (me[prop] !== null && +me[prop] !== NaN) {
          _this[prop] = +me[prop];
        }
      });
      return _this;
    });
  }

}

exports.default = Drink;